import LegalPage from './LegalPage';
const PrivacyPolicy = () => <LegalPage pageKey="privacy" />;
export default PrivacyPolicy;
